import React from 'react'
import { MapContainer, TileLayer } from 'react-leaflet'
import styles from './Maps.module.scss'
import 'leaflet/dist/leaflet.css'
import LocationMarker from './LocationMarker'
import { Location } from '../../../../types/types'
import Leaflet from 'leaflet'

const MAPTILER_API = process.env.REACT_APP_MAPTILER_API || ''
const MAPS_TYPE = process.env.REACT_APP_MAPS_TYPE || ''
const GEOCODING_TYPE = process.env.REACT_APP_GEOCODING_TYPE || ''

interface MapsProps {
  setPin: ({ newGuess }: { newGuess: Location }) => void
  currentGuess: Location | null
}

function Maps({ setPin, currentGuess }: MapsProps) {
  const defaultProps = {
    lat: 10.99835602,
    long: 77.01502627,
    zoom: 10,
  }
  const corner1 = Leaflet.latLng(-90, -360)
  const corner2 = Leaflet.latLng(90, 360)
  const bounds = Leaflet.latLngBounds(corner1, corner2)

  const handleMapClick = (lat: number, lng: number) => {
    getCountryName(lat, lng).then((country) => {
      // setPin({ lat: event.lat, lng: event.lng, country: country })
      setPin({
        newGuess: { lat: lat, long: lng, country: country },
      })
    })
  }

  async function getCountryName(lat: number, lng: number): Promise<string> {
    //return proper lat and long if out of bounds
    if (lat > 90) {
      lat = lat - 180
    } else if (lat < -90) {
      lat = lat + 180
    }
    if (lng > 180) {
      lng = lng - 360
    } else if (lng < -180) {
      lng = lng + 360
    }

    let fetchurl = ''
    if (GEOCODING_TYPE === 'MapTiler') {
      fetchurl = `https://api.maptiler.com/geocoding/${lng},${lat}.json?key=${MAPTILER_API}&language=en`
    } else if (GEOCODING_TYPE === 'self') {
      fetchurl = `https://languageguessr-nextjs.vercel.app/api/geocoding?lat=${lat}&lng=${lng}`
    }
    const response = await fetch(fetchurl)
    const data = await response.json()

    let country = ''
    if (GEOCODING_TYPE === 'MapTiler' && data.features.length > 0) {
      country = data.features[0].context.slice(-1)[0].text_en
    } else if (GEOCODING_TYPE === 'self') {
      country = data.country
    }

    return country
  }

  let mapsUrl = ''
  if (MAPS_TYPE === 'MapTiler') {
    mapsUrl = `https://api.maptiler.com/maps/5e30890f-8672-449f-9b0c-467f1c780d7d/{z}/{x}/{y}.png?key=${MAPTILER_API}`
  } else if (MAPS_TYPE === 'OpenStreetMap') {
    mapsUrl = 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png?lang=en'
  }

  return (
    <div className={styles.container}>
      <MapContainer
        maxBoundsViscosity={0.5}
        maxBounds={bounds}
        center={[defaultProps.lat, defaultProps.long]}
        minZoom={2}
        zoom={3}
        maxZoom={12}
      >
        <TileLayer
          url={mapsUrl}
          attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
        />
        <LocationMarker location={currentGuess} handleClick={handleMapClick} />
      </MapContainer>
    </div>
  )
}

export default Maps
